import type { LandingPageTestimonialsTheme } from '../types';

const getCardClasses = ({
  inverted,
  theme,
}: {
  inverted: boolean;
  theme: LandingPageTestimonialsTheme;
}): Record<string, boolean> => ({
  'bg-sandstone-400': !inverted,
  'text-sandstone-200': inverted,
  'bg-slate-400': inverted && theme === 'blue',
  'text-olive-800': !inverted && theme === 'green',
  'text-brown-600': !inverted && theme === 'brown',
});

export default getCardClasses;
